import { Box, Card, CardContent, Typography } from "@mui/material";
import NoRoleIcon from "../../assets/no-role-icon.svg";
import NoRoleHeader from "../../components/noRole/noRoleHeader";

const AccountDisabledPage = () => {
  return (
    <>
      <NoRoleHeader />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        bgcolor="#F9FAFB"
      >
        <Card
          sx={{
            maxWidth: 500,
            p: 4,
            textAlign: "center",
            border: "1.38px solid #E9E9E8",
            borderRadius: 2,
            boxShadow: "none",
          }}
        >
          <CardContent sx={{ gap: 2 }}>
            <Box display="flex" justifyContent="center" mb={2}>
              <img
                src={NoRoleIcon}
                alt="No Role Icon"
                style={{ width: 68, height: 68 }}
              />
            </Box>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ color: "#0E0D09" }}
              mb={1}
            >
              Account is disabled
            </Typography>
            <Typography variant="body1" sx={{ color: "#4E4B44" }} mb={2}>
              This account has been disabled and cannot be accessed at this
              time. Please contact the system administrator to get access
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default AccountDisabledPage;
